import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = () => ({
  total: 0,
  items: [],
  success: false
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};